import axios from "axios";
import config from "../../../config";
import {
  getHaklaiDealDocumentPrefix,
  HAKLAI_DOCUMENT_LABELS
} from "./haklaiDocumentsTexts";

const getHaklai2990JsonDownloadName = (dealTaxType, dealIndex, partsAmount) => {
  let fileName = HAKLAI_DOCUMENT_LABELS.form2990Online;
  if (partsAmount > 1) fileName = `${getHaklaiDealDocumentPrefix(dealIndex)} - ${fileName}`;
  if (dealTaxType === "linear") {
    fileName = `${HAKLAI_DOCUMENT_LABELS.oldLinear} - ${fileName}`;
  } else if (dealTaxType === "mutav") {
    fileName = `${HAKLAI_DOCUMENT_LABELS.mutav} - ${fileName}`;
  }
  return `${fileName}.json`;
};

const downloadJson = ({ data, fileName }) => {
  const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(data))}`;
  const aElement = document.createElement("a");
  aElement.setAttribute("href", dataStr);
  aElement.setAttribute("download", fileName);
  document.body.appendChild(aElement);
  aElement.click();
  aElement.remove();
};

const getResponseDataOrError = (response) => (
  response?.data || { err: "Problem with the request" }
);

const downloadBlob = ({ data, fileName }) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  if (window.URL.revokeObjectURL) window.URL.revokeObjectURL(url);
};

const generateHaklaiBlobDocument = async ({ url, data, fileName }) => {
  const response = await axios({
    url,
    method: "post",
    responseType: "blob",
    data
  });

  if (!response || !response.data) {
    throw new Error("Problem with request");
  }
  if (response.data.size < 250) {
    throw new Error("Empty document response");
  }

  downloadBlob({ data: response.data, fileName });
  return { success: true };
};

export const getHaklai2990Fields = async (dealId) => {
  const query = new URLSearchParams({
    dealId,
    isJust2990Fields: "true"
  });
  const response = await axios.get(`${config.getDocsFieldsEndpoint}?${query.toString()}`, { preventLoading: true });
  return getResponseDataOrError(response);
};

export const updateHaklai2990Fields = async (dealId, docFields) => {
  const response = await axios.post(config.update2990SpecificFieldsEndpoint, {
    dealId,
    data2990: docFields
  });
  return getResponseDataOrError(response);
};

export const generateHaklai2990Pdf = (docFields) => generateHaklaiBlobDocument({
  url: config.generate2990Endpoint,
  data: docFields,
  fileName: "2990.pdf"
});

export const generateHaklaiDeductions = (dealId) => generateHaklaiBlobDocument({
  url: config.generateDeductionEndpoint,
  data: { dealId },
  fileName: "ניכויים.pdf"
});

export const generateHaklai2990Json = async ({
  docFields,
  dealId,
  dealTaxType,
  dealIndex,
  partsAmount
}) => {
  const response = await axios({
    url: config.generate2990JsonEndpoint,
    method: "post",
    data: { ...docFields, dealId, dealTaxType, dealIndex }
  });

  if (!response || !response.data) {
    throw new Error("Problem with request");
  }

  downloadJson({
    data: response.data,
    fileName: getHaklai2990JsonDownloadName(dealTaxType, dealIndex, partsAmount)
  });
};
